// extracted by mini-css-extract-plugin
module.exports = {"place":"dashboard_place__1lib8","container":"dashboard_container__5et2j","graph":"dashboard_graph__1HQrX","progress":"dashboard_progress__1VMWl","bar":"dashboard_bar__UkEsx"};